lmApp.controller('ServersController', ['$scope', '$templateCache', '$compile', '$rootScope', 'ToastService', 'ContentNodeResource', 'NPVRNodeResource', 'AssetResource', 'DVRTasksResource', 'ManagerResource', 'ModalWindowService', 'TimezoneService', 'OperatorRsc',
    function ($scope, $templateCache, $compile, $rootScope, ToastService, ContentNodeResource, NPVRNodeResource, AssetResource, DVRTasksResource, ManagerResource, ModalWindowService, TimezoneService, OperatorRsc) {
        $scope.loading = false;
        $scope.contentNodes = [];
        $scope.catchupNodes = [];
        $scope.npvrNodes = [];

        $scope.catchupCount = -1;
        $scope.catchupDepth = '';
        $scope.successDVRTasks = -1;
        $scope.totalDVRTasks = -1;
        $scope.npvrState = '';
        $scope.npvrLimit = -1;
        $scope.sessionLimit = -1;

        // Timezone
        var timezone = _.find(TimezoneService.Timezones, {title: 'UTC'});
        $scope.tz = timezone.title;
        ManagerResource.get().$promise
            .then(function (result) {
                if (result.length !== 0) {
                    var manager = _.find(result, {username: $rootScope.globals.currentUser.username});
                    if (manager) {
                        timezone = _.find(TimezoneService.Timezones, {title: manager.ui_timezone || 'UTC'});
                        $scope.tz = timezone.title;
                    }
                }
            })
            .catch(function (reason) {
                $rootScope.debugInfo(reason, 'silent');
            });

        $scope.convertTime = function (dt) {
            return TimezoneService.addTimezoneToDate(dt, timezone)
        };

        //
        $scope.getOrigins = function () {
            $scope.loading = true;
            $rootScope.showLinearProgress('#serverLoader');

            $scope.contentNodes = [];
            $scope.catchupNodes = [];

            return ContentNodeResource.get().$promise
                .then(function (origins) {
                    for (var i = 0; i < origins.length; i++) {
                        var origin = origins[i];
                        var node = origin.node;
                        if (!node) continue;
                        origin._state = node.state === 'up' ? 'Up' : 'Down';
                        origin._sessions = node.version === 2 && origin.api === 2;
                        origin._address = node.url;
                        var pos = node.url.lastIndexOf("/content");
                        if (pos > 0) {
                            origin._address = node.url.substr(0, pos) + "/contentserver/v1/origin/status";
                        } else {
                            origin._address += "/contentserver/v1/origin/status";
                        }
                        var isCatchupServer = false;
                        var isNPVRServer = false;
                        for (var j = 0; j < node.tags.length; j++) {
                            var resource = node.tags[j];
                            if (resource.startsWith("catchup")) {
                                isCatchupServer = true;
                            }
                            if (resource.startsWith("npvr")) {
                                isNPVRServer = true;
                            }
                        }

                        var cdn = []
                        if (!origin.cdn) origin.cdn = [];
                        for (var j = 0; j < origin.cdn.length; j++) {
                            if (origin.cdn[j].url !== '') {
                                cdn.push(origin.cdn[j])
                            }
                        }

                        origin._cdn = cdn;

                        if (isCatchupServer) {
                            $scope.catchupNodes.push(origin);
                        } else if (!isNPVRServer) {
                            $scope.contentNodes.push(origin);
                        }
                    }
                    $scope.loading = false;
                    $rootScope.hideLinearProgress('#serverLoader');
                })
                .catch(function (reason) {
                    $scope.loading = false;
                    $rootScope.hideLinearProgress('#serverLoader');
                    $rootScope.debugInfo(reason);
                });
        };

        $scope.addEditCDN = function(node, cdn) {
            if ($scope.loading) return;

            $scope.cdnValidateErrors = {
                url: false,
            };
            $scope.cdn = {
                url: '',
                prefix: '/contentserver/v2/distributions',
                tag: '',
                priority: 100,
                group: 'everyone',
                node: node,
            };

            var cdnCopy = angular.copy(cdn);

            var editing = false;
            if (cdn !== undefined) {
                editing = true;
                $scope.cdn.url = cdn.url;
                $scope.cdn.tag = cdn.tag;
                $scope.cdn.prefix = cdn.prefix;
                $scope.cdn.priority = cdn.priority;
                $scope.cdn.group = cdn.group;
            }

            var inner = $templateCache.get('add-cdn.html');
            inner = $compile(inner)($scope);

            ModalWindowService.Open({
                content: inner,
                keyboard: true,
                actions: [
                    {
                        title: editing ? 'Save' : 'Create',
                        color: 'green',
                        check: function () {
                            var valid = true;
                            if (!$scope.cdn.url.startsWith('http')) {
                                $scope.cdnValidateErrors.url = true;
                                valid = false;
                            }
                            return valid;
                        },
                        fn: function () {
                            var saved = {
                                cdn: [],
                            }
                            if (node.api) {
                                saved.api = node.api;
                            }
                            if (editing) {
                                for (var i = 0; i < node.cdn.length; i++) {
                                    if (node.cdn[i].url === cdnCopy.url && node.cdn[i].tag === cdnCopy.tag && node.cdn[i].prefix === cdnCopy.prefix) {
                                        node.cdn[i].url = $scope.cdn.url;
                                        node.cdn[i].tag = $scope.cdn.tag;
                                        node.cdn[i].prefix = $scope.cdn.prefix;
                                        break;
                                    }
                                }
                                saved.cdn = node.cdn;
                            } else {
                                saved.cdn = node.cdn;
                                var newCdn = {
                                    url: $scope.cdn.url,
                                    prefix: $scope.cdn.prefix,
                                    tag: $scope.cdn.tag,
                                    priority: $scope.cdn.priority,
                                    group: $scope.cdn.group,
                                }
                                saved.cdn.push(newCdn)
                            }

                            ContentNodeResource.update({ id: node.node.id }, saved).$promise
                                .then(function (response) {
                                    $scope.getOrigins();
                                    ToastService.Small({
                                        title: 'The content node has been updated',
                                        color: 'green',
                                        icon: 'plus'
                                    }, 20 * 1000);
                                    return response
                                })
                                .catch(function (reason) {
                                    ToastService.Small({
                                        title: 'Failed to update content node: ' + _.get(reason, 'data.error.message', 'server error'),
                                        color: 'red',
                                        icon: 'delete'
                                    }, 30 * 1000);
                                });
                        }
                    },
                    {
                        title: 'Cancel',
                        color: 'red',
                        fn: function () {
                        }
                    }
                ]
            });
        };

        $scope.deleteCDN = function (node, cdn) {
            $scope.modalWindowScope = $scope.$new();
            var inner = '<span class="heavy">Are you sure you want <b>to delete</b> the CDN' + cdn.url +'"?</span>';

            ModalWindowService.Open({
                content: inner,
                actions: [
                    {
                        title: 'I understand. Do it',
                        color: 'green',
                        fn: function () {
                            var saved = {
                                cdn: [],
                            }
                            if (node.api) {
                                saved.api = node.api;
                            }
                            for (var i = 0; i < node.cdn.length; i++) {
                                if (node.cdn[i].url === cdn.url && node.cdn[i].tag === cdn.tag && node.cdn[i].prefix === cdn.prefix) {
                                    continue
                                }
                                saved.cdn.push(node.cdn[i])
                            }

                            ContentNodeResource.update({ id: node.node.id }, saved).$promise
                                .then(function (response) {
                                    $scope.getOrigins();
                                    ToastService.Small({
                                        title: 'The content node has been updated',
                                        color: 'green',
                                        icon: 'plus'
                                    }, 20 * 1000);
                                    return response
                                })
                                .catch(function (reason) {
                                    ToastService.Small({
                                        title: 'Failed to update content node: ' + _.get(reason, 'data.error.message', 'server error'),
                                        color: 'red',
                                        icon: 'delete'
                                    }, 30 * 1000);
                                });
                        }
                    },
                    {
                        title: 'cancel',
                        color: 'red',
                        fn: function () {}
                    }
                ],
                onComplete: function () {
                    $scope.modalWindowScope.$destroy();
                }
            });
        };

        $scope.getNPVRNodes = function () {
            $scope.loading = true;
            $rootScope.showLinearProgress('#serverLoader');

            return NPVRNodeResource.get().$promise
                .then(function (origins) {
                    for (var i = 0; i < origins.length; i++) {
                        var origin = origins[i];
                        var node = origin.node;
                        if (!node) continue;
                        origin._state = node.state === 'up' ? 'Up' : 'Down';
                        origin._capacity = (node.capacity / 1024 / 1024 / 1024).toFixed() + ' GB';
                        origin._address = node.url;
                        var pos = node.url.lastIndexOf("/content");
                        if (pos > 0) {
                            origin._address = node.url.substr(0, pos) + "/contentserver/v1/origin/status";
                        } else {
                            origin._address += "/contentserver/v1/origin/status";
                        }
                        $scope.npvrNodes.push(origin);
                    }
                    $scope.loading = false;
                    $rootScope.hideLinearProgress('#serverLoader');
                })
                .catch(function (reason) {
                    $scope.loading = false;
                    $rootScope.hideLinearProgress('#serverLoader');
                    $rootScope.debugInfo(reason);
                });
        };

        $scope.getAssets = function() {
            var params = {
                'type[eq]': 'channel',
                '$expand': 'resources'
            };
            AssetResource.get(params).$promise
                .then(function (assets) {
                    var catchupDepths = {};
                    var catchupCount = 0;
                    for (var i = 0; i < assets.length; i++) {
                        var asset = assets[i];
                        if (!asset.resources) continue;
                        for (var j = 0; j < asset.resources.length; j++) {
                            var resource = asset.resources[j];
                            if (resource.category === 'catchup' && resource.state === 'deployed') {
                                catchupCount += 1;
                                catchupDepths[resource.catchup_depth] = true;
                                break;
                            }
                        }
                    }
                    $scope.catchupCount = catchupCount;
                    var depths = [];
                    for (var d in catchupDepths) {
                        depths.push(Number(d));
                    }
                    if (depths.length === 0) {
                        $scope.catchupDepth = 'N/A';
                    } else if (depths.length === 1) {
                        $scope.catchupDepth = depths[0]/3600 + 'h';
                    } else {
                        var min = depths[0];
                        var max = depths[0];
                        for (var i = 0; i < depths.length; i++) {
                            if (depths[i] > max) {
                                max = depths[i];
                            }
                            if (depths[i] < min) {
                                min = depths[i];
                            }
                        }
                        $scope.catchupDepth = Math.round(min/3600) + 'h...' + Math.round(max/3600) + 'h';
                    }
                    return;
                })
                .catch(function (reason) {
                    $scope.catchupCount = 0;
                    $scope.catchupDepth = 'N/A';
                    $rootScope.debugInfo(reason);
                });
        };

        $scope.getDVRTasks = function() {
            var params = {
                'state[eq]': 'recorded'
            };
            DVRTasksResource.count(params).$promise
                .then(function (response) {
                    $scope.successDVRTasks = response.data ? response.data : 0;
                    return;
                })
                .catch(function (reason) {
                    $scope.successDVRTasks = 0;
                    $rootScope.debugInfo(reason);
                });

            DVRTasksResource.count().$promise
                .then(function (response) {
                    $scope.totalDVRTasks = response.data ? response.data : 0;
                    return;
                })
                .catch(function (reason) {
                    $scope.totalDVRTasks = 0;
                    $rootScope.debugInfo(reason);
                });
        };

        $scope.getOperator = function() {
            OperatorRsc.getCurrentOperator().$promise
                .then(function (response) {
                    $scope.npvrState = response.data.npvr ? 'enabled' : 'disabled';
                    $scope.npvrLimit = response.data.subscriber_npvr_limit ? response.data.subscriber_npvr_limit : 50;
                    $scope.sessionLimit = response.data.playback_session_limit ? response.data.playback_session_limit : 3;
                    return;
                })
                .catch(function (reason) {
                    $scope.npvrState = 'N/A';
                    $scope.npvrLimit = 50;
                    $scope.sessionLimit = 3;

                    $rootScope.debugInfo(reason);
                });
        };


        $scope.getOrigins();
        $scope.getNPVRNodes();
        $scope.getAssets();
        $scope.getDVRTasks();
        $scope.getOperator();
    }]);
